(function () {
    'use strict';

    angular
        .module('app')
        .factory('DocumentTemplatesService', DocumentTemplatesService);

    DocumentTemplatesService.$inject = ['$http', '$q', 'UrlService', 'Upload'];

    function DocumentTemplatesService($http, $q, UrlService, Upload) {

        var service = {
            getDocumentTemplates: getDocumentTemplates,
            getDocumentTemplate: getDocumentTemplate,
            deleteDocumentTemplate: deleteDocumentTemplate,
            saveDocumentTemplate: saveDocumentTemplate,
            getDocumentFile: getDocumentFile,
            getUsage: getUsage,
            multiCopy: multiCopy,
            multiDelete: multiDelete,
            count: count,
            validateDocumentTemplate: validateDocumentTemplate
        };

        return service;

        function getDocumentTemplates(pageSize, currentPage, genericSearch, entityTemplateId) {
            var firstParameter = true;
            var paramterString = '';

            if (!angular.isUndefined(pageSize) && pageSize !== null) {
                if (firstParameter) {
                    paramterString = '?PageSize=' + pageSize;
                    firstParameter = false;
                }
                else {
                    paramterString = paramterString + '&PageSize=' + pageSize;
                }
            }

            if (!angular.isUndefined(currentPage) && currentPage !== null) {
                if (firstParameter) {
                    paramterString = '?CurrentPage=' + currentPage;
                    firstParameter = false;
                }
                else {
                    paramterString = paramterString + '&CurrentPage=' + currentPage;
                }
            }

            if (!_.isNil(entityTemplateId)) {
                if (firstParameter) {
                    paramterString = '?EntityTemplateId=' + entityTemplateId;
                    firstParameter = false;
                }
                else {
                    paramterString = paramterString + '&EntityTemplateId=' + entityTemplateId;
                }
            }

            if (!angular.isUndefined(genericSearch) && genericSearch !== null) {
                if (firstParameter) {
                    paramterString = '?genericSearch=' + genericSearch;
                    firstParameter = false;
                }
                else {
                    paramterString = paramterString + '&genericSearch=' + genericSearch;
                }
            }

            var req = {
                method: 'GET',
                url: UrlService.getWebAPIUrl() + '/documenttemplate/' + paramterString,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            var promise = $http(req).then(
                // Success
                function (response) {
                    return response.data;
                },
                //Error
                function (response) {
                    return $q.reject(response);
                }
                );

            return promise;
        }

        function getDocumentTemplate(id, allowDeleted) {
            var url = UrlService.getWebAPIUrl() + '/documenttemplate/' + id;

            if (!_.isNil(allowDeleted)) {
                url += '?allowDeleted=' + allowDeleted;
            }

            var req = {
                method: 'GET',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            var promise = $http(req).then(
                // Success
                function (response) {
                    return response.data;
                },
                //Error
                function (response) {
                    return $q.reject(response);
                }
                );

            return promise;
        }

        function deleteDocumentTemplate(id) {
            var req = {
                method: 'DELETE',
                url: UrlService.getWebAPIUrl() + '/documenttemplate/' + id
            };

            var promise = $http(req).then(
                // Success
                function (response) {
                },
                //Error
                function (response) {
                    return $q.reject(response);
                }
                );

            return promise;
        }

        function saveDocumentTemplate(documentTemplate) {
            var req;

            var documentTemplateData = angular.copy(documentTemplate);

            if (!documentTemplate.Id) {
                req = {
                    method: 'POST',
                    url: UrlService.getWebAPIUrl() + '/documenttemplate/',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: documentTemplateData
                };
            } else {
                req = {
                    method: 'PUT',
                    url: UrlService.getWebAPIUrl() + '/documenttemplate/' + documentTemplate.Id,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: documentTemplateData
                };
            }

            var promise = $http(req).then(
            // Success
            function (response) {
                return $q.when(response.data);
            },
            //Error
            function (response) {
                return $q.reject(response);
            }
            );

            return promise;
        }

        function getDocumentFile(id, conversion) {
            var urlPath = UrlService.getWebAPIUrl() + '/documenttemplate/' + id + '/file';

            if (conversion === 'html') {
                urlPath = urlPath + '?conversion=html';
            }

            var req = {
                method: 'GET',
                url: urlPath,
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'arraybuffer'
            };

            var promise = $http(req).then(
                // Success
                function (response) {
                    return response;
                },
                //Error
                function (response) {
                    return $q.reject(response);
                }
                );

            return promise;
        }

        /*
         * Returns a list of where the document templates are used throughout ChilliDocs.
         *
         * @param {array} ids - List of document template ids for which the usage is to be returned
         *
         * @returns {array} List of 'Document Template Usage' (Refer to DocumentTemplateUsage.cs) of where the document templates are used.
         */
        function getUsage(ids) {
            var url = UrlService.getWebAPIUrl() + '/documenttemplate/usage';
            var parameterString = '';

            if (!_.isNil(ids) && _.isArray(ids)) {
                angular.forEach(ids, function (id) {
                    parameterString += parameterString.length > 0 ? '&' : '?';
                    parameterString += 'ids=' + id;
                });
            }

            url += parameterString;

            var req = {
                method: 'GET',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            var promise = $http(req).then(
                // Success
                function (response) {
                    return response.data;
                });

            return promise;
        }

        /**
         * Deletes the specified document templates
         *
         * @param {array} documentTemplateIds - An array of document template ids for the document templates to be deleted.
         * @return {promise} A promise resolved once the document template deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(documentTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/documenttemplatedelete', documentTemplateIds);
        }

        /**
         * Create copies of the specified document templates.
         *
         * @param {array} documentTemplateIds - An array of document template ids for the document templates to be copied.
         * @return {promise} A promise resolved once the document template copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(documentTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/documenttemplatecopy', documentTemplateIds);
        }

        /**
         * Gets the count of document templates
         *
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(deleted) {
            var url = UrlService.getWebAPIUrl() + '/documenttemplate/count';

            if (!_.isNil(deleted)) {
                url += '?deleted=' + deleted;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }

        function validateDocumentTemplate(documentTemplate, file) {
            var url = UrlService.getWebAPIUrl() + '/documenttemplate/validate';
            var requestMethod = 'POST';

            var savePromise;

            if (_.isNil(file)) {
                savePromise = $http({
                    method: requestMethod,
                    url: url,
                    data: documentTemplate
                });
            } else {
                savePromise = Upload.upload({
                    url: url,
                    data: {
                        files: [file],
                        jsonData: angular.toJson(documentTemplate)
                    },
                    method: requestMethod
                });
            }

            return savePromise.then(function (response) {
                return response.data;
            });
        }
    }
})();